import type { QuillTheme } from "@quillsql/react"
import { useTheme } from "next-themes"
import { CSSProperties } from "react"

export function getQuillTheme() {
    const { resolvedTheme } = useTheme()

    const theme: QuillTheme = {
        // Typography
        fontFamily: "var(--font-family-base)",
        fontSize: 16,

        // Backgrounds
        backgroundColor: "var(--surface-tertiary)",
        hoverBackgroundColor: "var(--surface-secondary)",

        // Text colors
        primaryTextColor: "var(--gray-12)",
        secondaryTextColor: "var(--gray-11)",

        // Chart styling
        chartLabelFontFamily: "var(--font-family-base)",
        chartLabelColor: "var(--gray-11)",
        chartTickColor: "var(--gray-6)",

        // Chart colors - using vibrant colors for better data visualization
        chartColors: [
            "var(--blue-9)",
            "var(--tomato-9)",
            "var(--jade-9)",
            "var(--amber-9)",
            "var(--cyan-9)",
            "var(--orange-9)",
            "var(--violet-9)",
            "var(--crimson-9)",
        ],

        // Borders
        borderColor: "var(--gray-a4)",
        borderWidth: 1,

        // Loading state
        loadingStateBackgroundColor: "var(--gray-a2)",

        // Dark mode
        // @ts-expect-error hidden internal api prop
        darkMode: resolvedTheme === "dark",
    }

    const chartContainerStyle: CSSProperties = {
        backgroundColor: "var(--surface-secondary)",
        borderRadius: "var(--border-radius-2)",
        border: "1px solid var(--gray-a4)",
        padding: "var(--size-4)",
        boxSizing: "border-box",
        minHeight: "200px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        height: "100%",
    }

    return { quillTheme: theme, chartContainerStyle }
}
